import { useState } from "react";
import { useCreate } from "../../hooks/useCreate";

import CSS from "./CSS.module.css";

const New = () => {
  const [fromClinic, setFromClinic] = useState("");
  const [toClinic, setToClinic] = useState("");

  const createDocument = useCreate();

  const handleSubmit = (e) => {
    e.preventDefault();
    createDocument({ fromClinic, toClinic });
  };

  return (
    <main className={CSS.main}>
      <h1>New</h1>
      <form onSubmit={handleSubmit}>
        <label>
          <input
            type="text"
            placeholder="from clinic"
            value={fromClinic}
            onChange={(e) => setFromClinic(e.target.value)}
          />
        </label>
        <label>
          <input
            type="text"
            placeholder="to clinic"
            value={toClinic}
            onChange={(e) => setToClinic(e.target.value)}
          />
        </label>
        <button>Create</button>
      </form>
    </main>
  );
};

export default New;
